<app-table-generic
  [table]="tableService.tableSubject"
  [data]="(tableService.dataTableGenericSubject$ | async)?.data || []"
  (onLazyLoad)="tableService.onLoadRecords($event, 2)"
  (onSelected)="tableService.onSelected($event)"
  [totalRecords]="(tableService.dataTableGenericSubject$ | async)?.totalRecords ?? 0"
  [showButtonCleanFilters]="true"
>
</app-table-generic>
